/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-28T09:56:25.431Z by lizhutang (lizhutang@spolo.org)

'use strict'

function proc ({ $content, $tplContent, buildInfo }) {
  // bootstrap 已经被内建支持。如果需要切换到foundation/material之类的库，由模板来决定。因此这里取消对bootstrap的检查。
  // if ($content.find('.col').length > 0 && $content.find('.row').length > 0) {
  //   buildInfo.prejs = buildInfo.prejs || []
  //   buildInfo.precss = buildInfo.precss || []
  //   let libSite = buildInfo.libsite || 'libs.wware.org'
  //   buildInfo.precss.push(`//${libSite}/bootstrap/4.1.3/css/bootstrap.min.css`)
  //   buildInfo.prejs.push(`//${libSite}/bootstrap/4.1.3/js/bootstrap.min.js`)
  //   // console.log(buildInfo)
  //   // console.log('proc Bootstrap')
  // }
}

export default proc
